requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!window.cartBase) {
      class CartBase {
        constructor() {
          this.cartData = {};
          this.sectionsToRender = [
            {
              id: "cart-icon-bubble",
              selectors: ["#cart-icon-bubble"],
            },
            {
              selectors: [
                "#main-cart-items-contents",
                "#main-cart-items-icon-bubble",
                "#cart-live-region-text",
              ],
              checkClass: [
                {
                  selector: "#MainCartItems",
                  className: "is-empty",
                },
              ],
            },
            {
              selectors: ["#main-cart-footer-contents"],
              checkClass: [
                {
                  selector: "#MainCartFooter",
                  className: "is-empty",
                },
              ],
            },
            {
              id: "cart-notification-product",
              selectors: ["#cart-notification-product"],
              dynamicSelector: () =>
                `#cart-notification-product-${this.lastProductId}`,
            },
            {
              selectors: [
                "#cart-drawer-heading",
                "#cart-drawer-items",
                // "#cart-drawer-upsell", // or '.upsell-nike-socks'
                "#cart-drawer-empty",
                "#cart-drawer-footer-cart-notes",
                "#cart-drawer-footer-subtotal",
              ],
              checkClass: [
                {
                  selector: "cart-drawer",
                  className: "is-empty",
                },
              ],
            },
          ];
        }

        updateSections(response, onLoadingToggle) {
          const sections = response.sections || {};

          this.getSectionsToRender().forEach((section) => {
            const sectionContent = sections[section.id];
            if (!sectionContent) {
              console.warn(`No content found for section ID: ${section.id}`);
              return;
            }

            lazyTemplateController
              .initializeFromHTML(sectionContent)
              .then((container) => {
                section.selectors.forEach((selector) => {
                  const target = section.content.querySelector(selector);
                  const replacement = container.querySelector(
                    section.dynamicSelector
                      ? section.dynamicSelector()
                      : selector
                  );

                  if (target && replacement) {
                    target.innerHTML = replacement.innerHTML;
                  } else {
                    console.warn(
                      `Selector "${selector}" not found in DOM or section content.`
                    );
                  }
                });

                this.checkClasses(
                  section.content,
                  container,
                  section.checkClass
                );
                container = null;
              });
          });

          if (onLoadingToggle) onLoadingToggle(false);
          this.onPublishEventFinish();
        }

        onPublishEventFinish() {
          if (this.publishEventFinish) {
            this.publishEventFinish();
            this.publishEventFinish = undefined;
          }
        }

        checkClasses(content, sectionDOM, checkClass) {
          if (!checkClass) return;

          checkClass.forEach((item) => {
            const target = content.querySelector(item.selector);
            const replacement = sectionDOM.querySelector(item.selector);

            if (target && replacement) {
              target.classList.toggle(
                item.className,
                replacement.classList.contains(item.className)
              );
            }
          });
        }

        validateSectionsInDOM() {
          this.filteredSectionsToRender = this.sectionsToRender.filter(
            (section) => {
              section.content = document
                .querySelector(section.selectors.join(","))
                ?.closest(".shopify-section");

              section.id =
                section.id ||
                section.content?.id?.replace("shopify-section-", "");

              if (!section.content || !section.id) {
                return false;
              }

              return true;
            }
          );

          return true;
        }

        getSectionsToRender() {
          if (!this.isSectionsValidated) {
            this.isSectionsValidated = this.validateSectionsInDOM();
          }

          return this.filteredSectionsToRender;
        }

        fetchSections() {
          const sections = this.getSectionsToRender()
            .map((section) => section.id)
            .join(",");
          return fetch(`${window.location.pathname}?sections=${sections}`).then(
            (response) => response.json()
          );
        }

        refreshCart(onLoadingToggle) {
          if (onLoadingToggle) onLoadingToggle(true);

          return this.fetchSections().then((response) => {
            const sections = response;
            this.cartData.sections = sections;
            this.updateSections(
              {
                sections,
              },
              onLoadingToggle
            );
          });
        }

        getData(onLoadingToggle) {
          return this.sendRequest({
            url: window.routes.cart_url,
            body: new FormData(),
            onLoadingToggle,
            updateCart: false,
          });
        }

        addToCart({
          body,
          onLoadingToggle,
          source = "product-form",
          target,
          enableEventCall = true,
        }) {
          if (this.errorTimeout) return;

          const productVariantId = body.get("id");
          this.lastProductId = productVariantId;

          this.sendRequest({
            url: window.routes.cart_add_url,
            body,
            target,
            onLoadingToggle,
            callback: (response) => {
              if (!response.errors) {
                if (enableEventCall) {
                  this.buildEvent(PUB_SUB_EVENTS.cartUpdate, {
                    source,
                    productVariantId,
                  });
                  this.publishEventFinish = () => {
                    this.buildEvent(PUB_SUB_EVENTS.cartUpdateFinish, {
                      source,
                      productVariantId,
                    });
                  };
                }
              }
            },
          });
        }

        updateQuantity({ line, quantity, target, onLoadingToggle }) {
          if (this.errorTimeout) return;

          const body = new FormData();
          body.append("line", line);
          body.append("quantity", quantity);

          this.sendRequest({
            url: window.routes.cart_change_url,
            body,
            onLoadingToggle,
            target,
            callback: (response) => {
              if (!response.errors) {
                this.buildEvent(PUB_SUB_EVENTS.quantityUpdate);

                this.publishEventFinish = () => {
                  this.buildEvent(PUB_SUB_EVENTS.quantityUpdateFinish);
                };
              }
            },
          });
        }

        sendRequest({
          url,
          body,
          onLoadingToggle,
          target,
          callback,
          updateCart = true,
        }) {
          if (onLoadingToggle) onLoadingToggle(true);

          body.append(
            "sections",
            this.getSectionsToRender().map((section) => section.id)
          );
          body.append("sections_url", window.location.pathname);

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          config.body = body;
          delete config.headers["Content-Type"];

          return fetch(url, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                response.errors = response.errors || response.description;

                const productVariantId = body.get("id");

                this.buildEvent(PUB_SUB_EVENTS.cartError, {
                  productVariantId: productVariantId,
                  errors: response.errors,
                  message: response.message,
                });

                if (
                  typeof response.errors === "object" &&
                  response.errors !== null
                ) {
                  this.errorFinish(
                    Object.values(response.errors).flat(),
                    target,
                    onLoadingToggle
                  );
                } else if (response.status !== 422) {
                  this.errorFinish(response.errors, target, onLoadingToggle);
                } else {
                  this.errorFinish(response.errors, target, onLoadingToggle);
                }
              }

              if (!response.errors && updateCart) {
                this.cartData = response;
                if (callback) callback(response);
                this.updateSections(response, onLoadingToggle);
                this.wasUpdate = true;
              }

              return response;
            });
        }

        errorFinish(errors, target, onLoadingToggle) {
          target.onError([].concat(errors));

          this.errorTimeout = setTimeout(() => {
            this.refreshCart((isLoading) => {
              onLoadingToggle(isLoading);
              if (!isLoading) target.onError([]);
              this.errorTimeout = null;
            });
          }, 2000);
        }

        buildEvent(event, params = {}) {
          params.cartData = this.cartData;
          publish(event, params);
        }

        toggleCartLoading({ isLoading, element, productForm, line }) {
          this.cartButton =
            this.cartButton || document.querySelector(".header__icon--cart");

          element?.classList.toggle("loading", isLoading);
          (productForm || element?.closest("product-form"))?.toggleCartLoading({
            isLoading,
          });

          if (isLoading && !this.cartButton.classList.contains("loading")) {
            this.cartButton.classList.add("loading");
            this.cartButton.addEventListener(
              "animationend",
              (event) => {
                this.cartButton.classList.remove("loading");
              },
              {
                once: true,
              }
            );
          }

          if (line) {
            document
              .querySelectorAll(`.loading-overlay[data-index="${line}"]`)
              .forEach((element) =>
                element.classList.toggle("hidden", !isLoading)
              );
          }
        }
      }

      window.cartBase = new CartBase();

      class CartRemoveButton extends HTMLElement {
        constructor() {
          super();
          this.addEventListener("click", this.onClickHandler.bind(this));
        }

        onClickHandler(event) {
          event.preventDefault();
          const line = this.dataset.index;

          cartBase.updateQuantity({
            line: line,
            quantity: 0,
            target: this,
            onLoadingToggle: (isLoading) => {
              cartBase.toggleCartLoading({
                isLoading,
                element: this,
                line,
              });
            },
          });
        }

        onError(errors) {
          document
            .querySelectorAll(
              `error-messages[data-index="${this.dataset.index}"]`
            )
            .forEach((element) => element.show(errors));
          document.querySelector("push-messages").push(errors);
        }
      }

      customElements.define("cart-remove-button", CartRemoveButton);

      class QuantityInput extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          themeBase.onDOMContentLoadedTrigger(() => {
            this.input = this.querySelector("input");
            this.minValue = Number(this.input.getAttribute("min")) || 0;
            this.maxValue = Number(this.input.getAttribute("max")) || Infinity;
            this.buttonMinus = this.querySelector('button[name="minus"]');
            this.buttonPlus = this.querySelector('button[name="plus"]');

            this.changeEvent = new Event("change", {
              bubbles: true,
            });

            [this.buttonMinus, this.buttonPlus].forEach((button) =>
              button.addEventListener("click", this.onButtonClick.bind(this))
            );

            this.input.addEventListener(
              "input",
              this.onInputValidation.bind(this)
            );
            this.input.addEventListener(
              "blur",
              this.onBlurValidation.bind(this)
            );
          });
        }

        callEvent() {
          this.input.dispatchEvent(this.changeEvent);
          this.buttonMinus.toggleAttribute(
            "disabled",
            Number(this.input.value) <= this.minValue
          );
          this.buttonPlus.toggleAttribute(
            "disabled",
            Number(this.input.value) >= this.maxValue
          );
        }

        onButtonClick(event) {
          event.preventDefault();
          const previousValue = this.input.value;

          event.target.name === "plus"
            ? this.input.stepUp()
            : this.input.stepDown();
          if (previousValue !== this.input.value) this.callEvent();
        }

        onInputValidation(event) {
          const value = event.target.value;

          const sanitizedValue = value.replace(/[^0-9]/g, "");

          if (sanitizedValue !== value) {
            this.input.value = sanitizedValue;
          }

          this.callEvent();

          if (sanitizedValue === "") {
            this.input.value = this.minValue;
            this.callEvent();
          }
        }

        onBlurValidation() {
          if (this.input.value === "" || isNaN(this.input.value)) {
            this.input.value = this.input.getAttribute("min") || "0";
          }
        }
      }

      customElements.define("quantity-input", QuantityInput);

      class CartQuantityInput extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('input[type="number"]');
          this.input.addEventListener(
            "change",
            debounce((event) => {
              this.onChangeHandler(event);
            }, 500)
          );
        }

        onChangeHandler(event) {
          const line = this.input.dataset.index;
          const quantity = parseInt(this.input.value, 10);

          cartBase.updateQuantity({
            line,
            quantity,
            target: this,
            onLoadingToggle: (isLoading) => {
              cartBase.toggleCartLoading({
                isLoading,
                element: this,
                line,
              });
            },
          });
        }

        onError(errors) {
          document
            .querySelectorAll(
              `error-messages[data-index="${this.input.dataset.index}"]`
            )
            .forEach((element) => element.show(errors));
          document.querySelector("push-messages").push(errors);
        }
      }

      customElements.define("cart-quantity-input", CartQuantityInput);

      class ErrorMessages extends HTMLElement {
        constructor() {
          super();
        }

        show(errors = []) {
          let stringHTML = "";

          errors.forEach((error) => {
            stringHTML += `<span class="error-line"><span>${error}</span>${window.cartStrings.errorIcon}</span>`;
          });

          this.innerHTML = stringHTML;
        }
      }

      customElements.define("error-messages", ErrorMessages);

      class PushMessages extends HTMLElement {
        constructor() {
          super();

          themeBase.onDOMContentLoadedTrigger(() => {
            this.content = this.querySelector(".push-messages__content");

            this.content.addEventListener("transitionend", () => {
              if (!this.classList.contains("push-messages--show")) {
                this.content.innerHTML = "";
              }
            });
          });
        }

        startHideTimeout(hideTimeout) {
          if (!this.classList.contains("push-messages--show")) return;

          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.toggle();
          }, hideTimeout);
        }

        push(errors = [], hideTimeout = 2000) {
          this.content = this.querySelector(".push-messages__content");

          if (!errors.length) {
            this.startHideTimeout(0);
            return;
          }

          let stringHTML = "";

          errors.forEach((error) => {
            stringHTML += `<span class="error-line"><span>${error}</span>${window.cartStrings.errorIcon}</span>`;
          });

          this.content.innerHTML = stringHTML;
          this.startHideTimeout(hideTimeout);
          this.toggle(true);
        }

        toggle(visible) {
          this.classList.toggle("push-messages--show", visible);
        }
      }

      customElements.define("push-messages", PushMessages);

      scriptController.scripts.push("cart.js");
      
    }
  });
});
